import T from 'prop-types';

export default {
  closeModal: T.func,
  getSubscription: T.func.isRequired,
  subscriptionPlans: T.arrayOf(
    T.shape({
      id: T.number.isRequired,
      title: T.string,
      description: T.string,
      price: T.shape({
        fractional: T.string.isRequired,
        currency: T.shape({
          id: T.string.isRequired
        })
      })
    })
  ),
  stripeApiKey: T.string,
  isModal: T.bool,
  isSubscribed: T.bool,
  isTablet: T.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/shapes/billing.js